import React, { FC, Fragment, useEffect } from 'react';
import { Select } from '@ui';
import { useFieldArray, useFormContext } from 'react-hook-form';
import useTranslation from '@app/hooks/use-translation';
import { OptionItem } from '@app/components/ui/select/select.type';
type NestedFieldPropsType = {
  nestIndex: number;
  fieldsLength: number;
  appendField(): void;
  options?: OptionItem[];
};
const NestedField: FC<NestedFieldPropsType> = ({
  nestIndex,
  appendField,
  fieldsLength,
  options,
}) => {
  const { t } = useTranslation('components.filter');
  const { control, watch, setValue } = useFormContext();
  const { fields, append } = useFieldArray({
    control,
    name: `operators[${nestIndex}].value`,
  });
  useEffect(() => {
    fields.length === 0 && append('');
  }, [append, fields, watch]);

  // function onAppendNestedField() {
  //   append('');
  // }

  // function onDeleteNestedField(fieldIndex: number) {
  //   remove(fieldIndex);
  // }

  return (
    <div className={'flex flex-col items-center '}>
      {fields?.map((item, fieldsIndex) => {
        return (
          <Fragment key={item.id}>
            {fieldsIndex !== 0 && (
              <div
                className={
                  'h-[17px] w-full flex items-center justify-center text-[14px] leading-[17px] font-[400] text-4color'
                }
              >
                {t('or')}
              </div>
            )}
            <div className={'w-[430px] transition-all flex items-center  relative cursor-pointer'}>
              <Select
                withSearch
                options={options || []}
                defaultValue={watch(`operators.[${nestIndex}].value[${fieldsIndex}]`)}
                onChange={(value) => {
                  if (fieldsLength === nestIndex + 1) {
                    appendField();
                  }
                  setValue(`operators.[${nestIndex}].value[${fieldsIndex}]`, value);
                }}
              />
              {/* {fieldsIndex !== fields.length - 1 ? (
                <CircleButton
                  size={14}
                  className="text-action absolute right-0 "
                  icon="MinusIcon"
                  onClick={() => onDeleteNestedField(fieldsIndex)}
                />
              ) : (
                <CircleButton
                  size={14}
                  className="text-action absolute right-0 "
                  icon="CirclePlusIcon"
                  onClick={onAppendNestedField}
                />
              )} */}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default NestedField;
